import http from '@/utils/services/http'

export default {
  lista (limit, page, filtros) {
    let url = '/api/comitente?page=' + page + '&limit=' + limit + filtros
    return http.get(url)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  find (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/comitente/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastro (data, id) {
    if (typeof id !== 'undefined') {
      return this.atualizacao(data, id)
    }
    return http.post('/api/comitente/', data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizacao (data, id) {
    return http.patch('/api/comitente/' + id, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deletar (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.delete('/api/comitente/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  alterarSenha (senha, id) {
    return http.patch('/api/usuarios/' + id + '/password', senha)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  criaUsuario (data, id) {
    return http.post('/api/usuarios/?role=comitente', data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  removeUsuario (id) {
    return http.delete('/api/usuarios/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  tiposComitente () {
    return http.get('/api/comitente/tipos')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  gruposComitente () {
    return http.get('/api/comitente/grupos')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  uploadFoto (data, id, cbUploadProgress) {
    return http.post('/api/comitente/' + id + '/uploadImagem', data, {headers: {'Content-Type': 'multipart/form-data'}, onUploadProgress: cbUploadProgress})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/comitentes/services/comitente.js